import { forwardRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { Badge, Avatar } from '@mui/material';
import { CustomAvatarProps } from './types';
import { OrderStatus } from '../../Common/enums';

// ----------------------------------------------------------------------

const getColorByRole = (loggedInIsEmployee: boolean, currentIsEmployee?: boolean) => {
  if (loggedInIsEmployee && currentIsEmployee === false) return 'avatarred';
  if (loggedInIsEmployee && currentIsEmployee === true) return 'avatarblue';
  if (!loggedInIsEmployee && currentIsEmployee === false) return 'avatarblue';
  if (!loggedInIsEmployee && currentIsEmployee === true) return 'avatarblue';
  return 'default';
};

const getCharAtName = (name: string) => name && name.charAt(0).toUpperCase();

// ----------------------------------------------------------------------

const CustomAvatar = forwardRef<HTMLDivElement, CustomAvatarProps>(
  ({ color, name = '', loggedInIsEmployee, currentIsEmployee, BadgeProps, status, children, sx, ...other }, ref) => {
    const theme = useTheme();
    const colorByRole = getColorByRole(loggedInIsEmployee, currentIsEmployee);
    const charAtName = getCharAtName(name);

    const renderContent =
      (
        <Avatar
          ref={ref}
          sx={{
            color: status === OrderStatus.Passive || colorByRole === "avatarblue" || colorByRole === "avatarred" ? "#fff" : theme.palette[color!]?.contrastText,
            backgroundColor: status === OrderStatus.Passive ? "grey" : colorByRole === "avatarblue" ? "#8FAEC7" : colorByRole === "avatarred" ? "#F3837B"  : theme.palette[color!]?.main,
            fontWeight: theme.typography.fontWeightMedium,
            ...sx,
          }}
          {...other}
        >
          {name && charAtName}
          {children}
        </Avatar>
      );

    return BadgeProps ? (
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        {...BadgeProps}
      >
        {renderContent}
      </Badge>
    ) : (
      renderContent
    );
  }
);

export default CustomAvatar;
